module.exports = __webpack_public_path__ + "static/img/icon_none.3e14496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_none.png
// module id = 54R9
// module chunks = 167